import { render } from "./CadastraFornecedor.vue?vue&type=template&id=72bcee4a"
import script from "./CadastraFornecedor.vue?vue&type=script&lang=js"
export * from "./CadastraFornecedor.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__